import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "field mt-3" }
const _hoisted_2 = { class: "field mt-3" }
const _hoisted_3 = { class: "flex flex-wrap gap-3 mt-3" }
const _hoisted_4 = { class: "field flex-1" }
const _hoisted_5 = { class: "field flex-1" }
const _hoisted_6 = { class: "field flex-1" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "dialog-footer flex justify-content-end" }

import { onMounted, ref, Ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { helpers, numeric, required } from '@vuelidate/validators';
import AutoComplete from 'primevue/autocomplete';

import { EMIT } from '@/enum';
import { useCitiesStore, useStatesStore, useTenantStore } from '@/store';
import { storeToRefs } from 'pinia';

//phone number regex helper validator

export default /*@__PURE__*/_defineComponent({
  __name: 'AddTenant',
  emits: [EMIT.NEXT, EMIT.BACK, EMIT.SAVE],
  setup(__props, { emit: __emit }) {

const number = helpers.regex(/^[0-9]{3}-[0-9]{3}-[0-9]{4}$/);
const zipcode = helpers.regex(/^\d{5}(-\d{4})?$/);

const emit = __emit;
const stateStore = useStatesStore();
const citiesStore = useCitiesStore();
const tenantStore = useTenantStore();

/**
 * The data ref object for newTenant so you can come back to the newTenant.
 */
const { newTenant } = storeToRefs(tenantStore);

/**
 * The suggested cities after running a search.
 */
const cities = ref([]);

/**
 * The required validation rules.
 */
const rules = {
  name: { required },
  street: { required },
  city_name: { required },
  state_id: { required },
  zip: { required, numeric, zipcode: helpers.withMessage('Zipcode must be valid', zipcode) },
  phone: { required, number: helpers.withMessage('Phone must be in format 123-456-7890', number) },
};

/**
 * Initialize the vuelidate instance.
 */
const v$ = useVuelidate(rules, newTenant);

/**
 * Determines whether or not the form has been submitted.
 */
const submitted = ref<boolean>(false);

onMounted(() => {
  init();
});

const init = async () => await stateStore.getStates();

/**
 * Handle the client side validation, followed by saving the
 * information for the new user account.
 */
const onSave = () => {
  if (v$.value.$invalid) return;
  emit(EMIT.NEXT);
};

/**
 * Search for a city with the provided city name, state and country identifier.
 * Also, Attempt to pre-populate the state based on the provided city name.
 */
const onCitySearch = async () => {
  if (newTenant.value.state_id && newTenant.value.city_name) {
    const params = {
      country_id: 1,
      search: newTenant.value.city_name,
    };

    citiesStore.searchCities(params).then((response) => (cities.value = response.data.data));
  } else {
    const response = await citiesStore.searchCities({ search: newTenant.value.city_name });
    const stateIds = response.data.data.map((item) => item);

    if (stateIds.length === 1) {
      newTenant.value.state_id = stateIds[0].state_id;
      newTenant.value.city_id = stateIds[0].id;
    }
  }
};

/**
 * Update the city, state and country identifiers once a suggested
 * city has been selected.
 */
const onCityUpdate = (event: Ref) => {
  newTenant.value.city_id = event.value.id;
  newTenant.value.city_name = event.value.name;
  newTenant.value.state_id = event.value.state_id;
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("label", {
        class: "required",
        for: "name"
      }, "Tenant Name", -1)),
      _createVNode(_component_InputText, {
        id: "name",
        modelValue: _unref(v$).name.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event)),
        type: "text",
        placeholder: "Tenant Name",
        disabled: submitted.value,
        class: "w-full"
      }, null, 8, ["modelValue", "disabled"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).name.$errors, (error) => {
        return (_openBlock(), _createElementBlock("div", {
          key: error.$uid,
          class: "input-errors"
        }, [
          _createElementVNode("small", null, _toDisplayString(error.$message), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("label", {
        class: "required",
        for: "street"
      }, "Address", -1)),
      _createVNode(_component_InputText, {
        id: "street",
        modelValue: _unref(v$).street.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).street.$model) = $event)),
        type: "text",
        placeholder: "Tenant Address",
        disabled: submitted.value,
        class: "w-full"
      }, null, 8, ["modelValue", "disabled"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).street.$errors, (error) => {
        return (_openBlock(), _createElementBlock("div", {
          key: error.$uid,
          class: "input-errors"
        }, [
          _createElementVNode("small", null, _toDisplayString(error.$message), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[8] || (_cache[8] = _createElementVNode("label", {
          class: "required",
          for: "city"
        }, "City", -1)),
        _createVNode(_unref(AutoComplete), {
          id: "city",
          modelValue: _unref(v$).city_name.$model,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).city_name.$model) = $event)),
          class: "city_name mr-2",
          field: "name",
          "min-length": 2,
          placeholder: "City",
          suggestions: cities.value,
          onComplete: onCitySearch,
          onItemSelect: onCityUpdate
        }, null, 8, ["modelValue", "suggestions"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).city_name.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            key: error.$uid,
            class: "input-errors"
          }, [
            _createElementVNode("small", null, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[9] || (_cache[9] = _createElementVNode("label", {
          class: "required",
          for: "state_id"
        }, "State", -1)),
        _createVNode(_component_Dropdown, {
          id: "state_id",
          modelValue: _unref(v$).state_id.$model,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).state_id.$model) = $event)),
          options: _unref(stateStore).states,
          "option-label": "name",
          "option-value": "id",
          placeholder: "State",
          class: "w-full"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[10] || (_cache[10] = _createElementVNode("label", {
          class: "required",
          for: "state_id"
        }, "Zipcode", -1)),
        _createVNode(_component_InputText, {
          id: "zip",
          modelValue: _unref(v$).zip.$model,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).zip.$model) = $event)),
          type: "text",
          placeholder: "Zipcode",
          disabled: submitted.value,
          class: "w-full"
        }, null, 8, ["modelValue", "disabled"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).zip.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            key: error.$uid,
            class: "input-errors"
          }, [
            _createElementVNode("small", null, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[11] || (_cache[11] = _createElementVNode("label", {
        class: "required",
        for: "phone"
      }, "Phone", -1)),
      _withDirectives(_createVNode(_component_InputText, {
        id: "phone",
        modelValue: _unref(v$).phone.$model,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).phone.$model) = $event)),
        type: "text",
        placeholder: "Phone",
        disabled: submitted.value,
        class: "w-full"
      }, null, 8, ["modelValue", "disabled"]), [
        [_directive_maska, '###-###-####']
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).phone.$errors, (error) => {
        return (_openBlock(), _createElementBlock("div", {
          key: error.$uid,
          class: "input-errors"
        }, [
          _createElementVNode("small", null, _toDisplayString(error.$message), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_AppButton, {
        "icon-left": "arrow_forward",
        type: "secondary",
        text: "Next",
        class: "admin-button",
        disabled: _unref(v$).$invalid || submitted.value,
        onClick: onSave
      }, null, 8, ["disabled"])
    ])
  ], 64))
}
}

})